export const state = [
	{
		id: 65,
		country: "egypt",
		countryName: "Egypt",
		states: [
			{
				id: 3235,
				name: "Alexandria",
				state_code: "ALX",
				hasCities: true,
				lat: 31.205753,
				lon: 29.924526, // Alexandria city :contentReference[oaicite:0]{index=0}
			},
			{
				id: 3225,
				name: "Aswan",
				state_code: "ASN",
				hasCities: true,
				lat: 24.088938,
				lon: 32.89983, // Aswan city :contentReference[oaicite:1]{index=1}
			},
			{
				id: 3236,
				name: "Asyut",
				state_code: "AST",
				hasCities: true,
				lat: 27.180134,
				lon: 31.189283, // Asyut city :contentReference[oaicite:2]{index=2}
			},
			{
				id: 3241,
				name: "Beheira",
				state_code: "BH",
				hasCities: true,
				lat: 31.19256,
				lon: 31.52046, // Sherbeen, Dakahlia (center point not exact, but nearby) :contentReference[oaicite:3]{index=3}
			},
			{
				id: 3230,
				name: "Beni Suef",
				state_code: "BNS",
				hasCities: true,
				lat: 29.088413,
				lon: 31.119085, // Manqarish, Beni Suef :contentReference[oaicite:4]{index=4}
			},
			{
				id: 3223,
				name: "Cairo",
				state_code: "C",
				hasCities: true,
				lat: 29.953756,
				lon: 31.537, // Cairo city :contentReference[oaicite:5]{index=5}
			},
			{
				id: 3245,
				name: "Dakahlia",
				state_code: "DK",
				hasCities: true,
				lat: 31.037933,
				lon: 31.381523, // Mansoura, Dakahlia :contentReference[oaicite:6]{index=6}
			},
			{
				id: 3224,
				name: "Damietta",
				state_code: "DT",
				hasCities: true,
				lat: 31.41754,
				lon: 31.814444, // Damietta city :contentReference[oaicite:7]{index=7}
			},
			{
				id: 3238,
				name: "Faiyum",
				state_code: "FYM",
				hasCities: true,
				lat: 29.05, // Approximate city center :contentReference[oaicite:8]{index=8}
				lon: 31.1, // (rounded)
			},
			{
				id: 3234,
				name: "Gharbia",
				state_code: "GH",
				hasCities: true,
				lat: 30.8, // Approximate (regionally near Tanta)
				lon: 31.0,
			},
			{
				id: 3239,
				name: "Giza",
				state_code: "GZ",
				hasCities: true,
				lat: 30.013056,
				lon: 31.208853, // Giza city :contentReference[oaicite:9]{index=9}
			},
			{
				id: 3244,
				name: "Ismailia",
				state_code: "IS",
				hasCities: true,
				lat: 30.6, // Approximate
				lon: 32.25,
			},
			{
				id: 3222,
				name: "Kafr el-Sheikh",
				state_code: "KFS",
				hasCities: true,
				lat: 31.1, // Approximate
				lon: 31.1,
			},
			{
				id: 3242,
				name: "Luxor",
				state_code: "LX",
				hasCities: true,
				lat: 25.687243,
				lon: 32.639637, // Luxor city :contentReference[oaicite:10]{index=10}
			},
			{
				id: 3231,
				name: "Matrouh",
				state_code: "MT",
				hasCities: true,
				lat: 31.354343,
				lon: 27.237316, // Mersa Matruh :contentReference[oaicite:11]{index=11}
			},
			{
				id: 3243,
				name: "Minya",
				state_code: "MN",
				hasCities: true,
				lat: 28.1, // Approximate
				lon: 30.75,
			},
			{
				id: 3228,
				name: "Monufia",
				state_code: "MNF",
				hasCities: true,
				lat: 30.5, // Approximate (center of region)
				lon: 31.0,
			},
			{
				id: 3246,
				name: "New Valley",
				state_code: "WAD",
				hasCities: true,
				lat: 25.447615,
				lon: 30.555038, // Kharga, New Valley :contentReference[oaicite:12]{index=12}
			},
		],
	},
	{
		id: 194,
		country: "saudi arabia",
		countryName: "Saudi Arabia",
		states: [
			{
				id: 9401,
				name: "Southern",
				state_code: "SO",
				hasCities: true,
				lat: 18.306,
				lon: 42.729,
			},
			{
				id: 9402,
				name: "Eastern",
				state_code: "EA",
				hasCities: true,
				lat: 26.4207,
				lon: 50.0888,
			},
			{
				id: 9403,
				name: "Northern",
				state_code: "NO",
				hasCities: true,
				lat: 26.0,
				lon: 38.5,
			},
			{
				id: 9404,
				name: "Western",
				state_code: "WE",
				hasCities: true,
				lat: 21.49,
				lon: 39.6,
			},
			{
				id: 9405,
				name: "Central",
				state_code: "CE",
				hasCities: true,
				lat: 24.7136,
				lon: 46.6753,
			},
		],
	},
];
